<script>
import Layout from "../../../layouts/main";
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";
import { useTransferUserStore } from '@/store/transferUserStore'

import Swal from "sweetalert2";


import { ref } from "vue";


/**
 * Dashboard Component
 */
export default {
    setup() {
        const doesAddOpen = ref(false);
        const doesEditOpen = ref(false);
        const doesDeleteOpen = ref(false);
        const doesLoadingOpen = ref(false);
        const transferUserStore = useTransferUserStore();


        return {
          doesAddOpen,
          doesEditOpen,
          doesDeleteOpen,
          doesLoadingOpen,
          transferUserStore,

        };
    },
    page: {
    title: "TransferUsers",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
  },
  data() {
    return {
      title: "transferUser",
      items: [
        {
          text: "Menu",
        },
        {
          text: "transferUser",
          active: true,
        },
      ],
      errors: [],
      transferUsers: [],
      transfer_search: [],
      state: "",
      states: [{
        "key": "TOUT"
      }, {
        "key": "EN ATTENTE"
      }, {
        "key": "PROUVEE"
      }, {
        "key": "EN COURS"
      }, {
        "key": "TRANSFERER"
      }, {
        "key": "TERMEINE"
      }, {
        "key": "ECHOUE"
      }],
      search: '',
      loading: false,
      status: 201,
      page: 1,
      length: 0,
      perPage: 25,
    };
  },
  methods: {


    
     
  async loadFromStore() {

      if (!this.transferUserStore.list) {
       await  this.transferUserStore.loadFromApi(true).then(data => {
        this.transferUsers = data
        this.transferUser_search = data;
        this.length = this.transferUsers.length;
        })
      } else {
        this.transferUsers = this.transferUserStore.list
        this.transferUser_search = this.transferUsers;
        this.length = this.transferUsers.length;
      }

  },

  async refresh(){
    await  this.transferUserStore.loadFromApi(true).then(data => {
        this.transferUsers = data
        this.transferUser_search = data;
        this.length = this.transferUsers.length;
    })
  },


    show(index) {
        return (index < this.page * this.perPage && (index + 1) > (this.page - 1) * this.perPage)
    },
    next() {
        if ((this.page * this.perPage) < this.transferUsers.length) {
            this.page++
        }
    },
    previous() {
        if (this.page >= 2) {
            this.page--
        }
    },
    filter_transfer() {
      this.transferUsers = this.transfer_search
      if (this.search != "") {
        this.transferUsers = this.transferUsers.filter(transferUser => (
          transferUser.idOfTransfer?.includes(this.search) ||
          transferUser.idOfAgent?.includes(this.search) ||
          transferUser.payId?.includes(this.search) ||
          transferUser.provenAt?.includes(this.search) ||
          transferUser.confirmedAt?.includes(this.search) ||
          transferUser.cancelledAt?.includes(this.search) 
          ))
      }
    },
   

    compileToClipboard(text) {
      navigator.clipboard.writeText(text).then(() => {
        const Toast = Swal.mixin({
          toast: true,
          position: "top-end",
          showConfirmButton: false,
          timer: 3000,
          timerProgressBar: true,
          didOpen: (toast) => {
            toast.onmouseenter = Swal?.stopTimer;
            toast.onmouseleave = Swal?.resumeTimer;
          }
        });
        Toast.fire({
          icon: "success",
          title: "Le texte a été copié dans le presse-papier.",
        });
      });
      
    },


  },
  mounted() {
    this.loadFromStore()
    this.doesLoadingOpen = false
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="hstack mb-3" v-show="status != 403">
      
       <b-button variant="primary" @click="refresh()" class="ms-auto">
        <i class=" bx bx-refresh font-size-16 align-middle me-2"></i>
        Refresh
      </b-button>
     
    </div>

    <div class=" row mb-3" v-show="status != 403">
      <div class="col-6  col-md-4 ">
        <input 
        type="search" class="form-control"
         v-model="search" 
         v-on:input="filter_transfer()" 
         placeholder="Rechercher une transfer">
      </div>

      <div class="col-4 col-sm-2 ms-auto ms-md-3">
        <select name="" id="" v-model="state" class="form-control text-center bg-secondary text-white">
          <option value="">Statut</option>
          <option v-for="state in states" :key="state.key" :value="state.key">{{ state.key }}</option>
        </select>
      </div>

      <div class=" col-5 col-sm-2 ms-0 ms-md-3 mt-3 mt-md-0">
        <select v-model="perPage" class="form-control text-center">
          <option value="10">10</option>
          <option value="25">25</option>
          <option value="50">50</option>
          <option value="100">100</option>
          <option value="500">500</option>
        </select>
      </div>

      <div class="ms-auto   col-6 col-sm-2 ps-5  mt-4 mt-md-0 ms-md-3">
        <i class="bx bx-left-arrow-alt p-2 fs-5 fs-sm-1" type="button" @click="previous"></i>
        
        <small class="ms-3 ">
          {{ Math.ceil(transferUsers.length / perPage) > 0 ? page : 0 }} /
          {{ Math.ceil(transferUsers.length / perPage) }}
        </small>

        <i class="bx bx-right-arrow-alt fs-5 fs-sm-1 p-2 ms-3 " type="button" @click="next"></i>
      </div>


    </div>

    <div class="row" v-show="status != 403">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title">Listes des transfers</h4>
            <p class="card-title-desc">
              Le tableau ci-dessous présente la listes des <code>transfers</code>.
            </p>

            <div class="table-responsive">
              <table class="table align-middle mb-0">
                <thead class="bg-light rounded">
                  <tr>
                    <th>#</th>
                    <th>Sender</th>
                    <th>Receiver</th>
                    <th>From</th>
                    <th>To</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(trans, i) in transferUsers" v-show="show(i)" :key="trans.id">
                    
                    <td>  {{ trans.sender?.firstName }} {{ trans.sender?.lastName }} ({{ trans.fromAccount }}) </td>
                    <td>  {{ trans.receiver?.firstName ?? '' }} {{ trans.receiver?.lastName ?? '' }}  ({{ trans.toAccount }})</td>

                    <td>{{ trans.from?.name_fr }}</td>
                    <td>{{ trans.to?.name_fr ?? trans.name  }}</td>

                    <td>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>


          </div>
        </div>
      </div>
    </div>


    <div v-show="status === 403">
      <h3 class="text-danger text-center my-5">Vous n'êtes pas encore ajouté, demandez à l'administrateur principal.</h3>
    </div>

    <!-- LOADING MODAL -->
    <b-modal v-model="doesLoadingOpen" id="modal-center" centered size="md" title="Chargement..."
      title-class="font-18" hide-footer>
      <div class="text-center">
        <div class="spinner-border text-primary-" role="status">
          <span class="visually-hidden">Loading...</span>
        </div>
      </div>
    </b-modal>

  </Layout>
</template>
